module.exports = __webpack_public_path__ + "img/lens-174-plus-02.89d1bd97.png";